import React from 'react';


// DEFAULT COMPONENT
const ModalBottomSheetKoglovoPresentational = (props) => {
  let is_opened = false;
  if (props.opened === true) {
    is_opened = true;
  }
  let clLarge = '';
  if (props.options && props.options.large === true) {
    clLarge = ' modal-bottom-sheet-koglovo__modal-wrapper--large';
  }

  /*
  let cl = "modal-overlay";
  if (modal.animateOut === true) {
    cl += ' animate-close';
  }
  */

  return (
    <div className={"modal-bottom-sheet-koglovo" + (is_opened ? " modal-bottom-sheet-koglovo--is-opened" : "")}>
      <div className="modal-bottom-sheet-koglovo__overlay modal-bottom-sheet-koglovo__overlay--sheet-to-window-enabled">
        <div className={"modal-bottom-sheet-koglovo__modal-wrapper" + clLarge}>
          <div className={"modal-bottom-sheet-koglovo__card"}>
            <div className="modal-bottom-sheet-koglovo__card__pan-header bottom-sheet__pan">
              <div className="modal-bottom-sheet-koglovo__card__bar bottom-sheet__bar" onClick={(e) => {
                if (typeof props.cbClose === 'function') {
                  props.cbClose();
                }
              }}></div>
              <div className="modal-bottom-sheet-koglovo__close" onClick={(e) => {
                if (typeof props.cbClose === 'function') {
                  props.cbClose();
                }
              }}>&times;</div>
            </div>
            <div className="modal-bottom-sheet-koglovo__card__body bottom-sheet__content">{props.children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalBottomSheetKoglovoPresentational;